import React from 'react'
import Hero from '@/components/ai/Hero'
import Spacer from '@/components/ai/Spacer'
import Template from '@/components/ai/Template'
import Sec2 from '@/components/ai/Sec2'
import Sec3 from '@/components/ai/Sec3'
import Sec4 from '@/components/ai/Sec4'
import Sec5 from '@/components/ai/Sec5'
import FAQ from '@/components/ai/FAQ'
import { Container } from '@/components'
import { useTranslation } from '@/utils/hook'

const Ai = () => {
  const t = useTranslation()

  return (
    <Container
      url="/ai"
      //   title={t('metadata.ai.title')}
      //   description={t('metadata.ai.description')}
      title={t('Smarter forms, AI-driven')}
      description={t(
        'Design forms faster and smarter - let our AI assist you every step of the way.'
      )}
    >
      <div className="xl:max-w-[1024px] lg:max-w-[892px] md:max-w-[636px] px-[16px] md:px-0 mx-auto">
        <div id="1">
          <Hero />
        </div>
        <Spacer />
        <div id="2">
          <Sec2 />
        </div>
        <Spacer />
        <div id="3">
          <Sec3 />
        </div>
        <Spacer />
        <div id="4">
          <Sec4 />
        </div>
        <Spacer />
        <div id="5">
          <Sec5 />
        </div>
        <Spacer />
        <div id="6">
          <Template />
        </div>
        <Spacer />
        <FAQ />
      </div>
    </Container>
  )
}

export default Ai
